import axios from 'axios';

const REACT_APP_BASE_URL: string | undefined = process.env.REACT_APP_BASE_URL
  ? process.env.REACT_APP_BASE_URL
  : '/';

const http = axios.create({
  baseURL: REACT_APP_BASE_URL,
});

export const fetchInfo = async (): Promise<string> => {
  const response = await http.get('/api/info');

  return response.data;
};

export const fetchProject = async (id: string): Promise<any> => {
  const response = await http.get(`/api/project/${id}`);

  return response.data;
};

export const login = async (
  token: string,
  email: string,
  lang: string
): Promise<any> => {
  const response = await http.post(`/api/project/${token}/join`, {email, lang});

  return response.data;
};

export const playTokenCheck = async (token: string): Promise<any> => {
  const response = await http.post('/api/play/token-check', {token});

  return response.data;
};

export const getPlayInfo = async (token: string): Promise<any> => {
  const response = await http.get(`/api/play/info`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const onboarding = async (
  formData: any,
  token: string
): Promise<any> => {
  const response = await http.post('/api/play/on-boarding', formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const updateLanguage = async (
  language: string,
  token: string
): Promise<any> => {
  const response = await http.post(
    '/api/experience/language',
    {
      language,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const playSession = async (token: string): Promise<any> => {
  const response = await http.post(
    '/api/play/session',
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

//dashboard hr
export const loginHr = async (token: string, email: string) => {
  const response = await http.post(`/api/hr/login`, {token, email});

  return response.data;
};

export const fetchHrCustomer = async (token: string): Promise<HRCustomer> => {
  const res = await http.get(`/api/hr/customer`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const getCustomerPublicInfo = async (
  customerId: string
): Promise<HRCustomerPublicInfo> => {
  const res = await http.post(`/api/hr/public/customer/${customerId}/info`);

  return res.data;
};

export const fetchHrProject = async (
  jwtToken: string,
  token: string
): Promise<HRProject> => {
  const response = await http.get(`/api/hr/project/${token}`, {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  });

  return response.data;
};

export const getHrExperiences = async (
  token: string,
  query?: string
): Promise<HRExperience[]> => {
  const response = await http.get(`api/hr/experiences${query ? query : ''}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

type SendEmailsParams = {
  jwtToken: string;
  token: string;
  body: {
    emails: string;
    subject: string;
    lang: 'en' | 'it' | 'es' | 'pl';
    message?: string;
  };
};

export const sendEmails = async (params: SendEmailsParams): Promise<any> => {
  const response = await http.post(
    `/api/hr/project/${params.token}/invitation-email`,
    params.body,
    {
      headers: {
        Authorization: `Bearer ${params.jwtToken}`,
      },
    }
  );

  return response.data;
};

export const getEmailsLogs = async (
  jwtToken: string,
  query: string
): Promise<HRLog[]> => {
  const response = await http.get(`/api/hr/email-logs${query ? query : ''}`, {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  });

  return response.data;
};
